import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { IGetBusinessPossibleAppointmentsResponse } from 'shared/repositories/announcements/v1/get-business-possible-appointments';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { QueryError, QueryKey, getQueryKey } from './internal/config';
import { fetchGetBusinessPossibleAppointmentsService } from './internal/fetchService';

export function useGetBusinessPossibleAppointmentsQuery<TData = IGetBusinessPossibleAppointmentsResponse>(
  options?: UseQueryOptions<IGetBusinessPossibleAppointmentsResponse, QueryError, TData, QueryKey>,
): UseQueryResult<TData, QueryError> {
  const context = useApplicationContext();

  return useQuery<IGetBusinessPossibleAppointmentsResponse, QueryError, TData, QueryKey>({
    queryFn: () => fetchGetBusinessPossibleAppointmentsService(context),
    queryKey: getQueryKey(),
    ...options,
  });
}
